import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type { UploadFiles, FileUploadPreCheck } from '@trinity/chat/api/interfaces/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ChatUploadApiContext, ChatUploadApiContextValue } from '@trinity/chat-components/containers/Chat.FileUpload/context.js';

type Props = {
  children: React.ReactNode;
};

export const GenAiChatUploadProvider = ({ children }: Props) => {
  const apiClient = useChatApiClient();

  const contextValue: ChatUploadApiContextValue = {
    usePreCheckMutation: () => useMutation<
      FileUploadPreCheck.Response,
      AxiosResponse,
      FileUploadPreCheck.Request
    >({
      mutationFn: data => {
        return apiClient.chat.fileUploadPreCheck({
          chatInstanceIdentifier: data.chatInstanceIdentifier,
          files: data.files,
          parentObjectId: data.parentObjectId,
        });
      },
    }),

    useUploadMutation: () => useMutation<
      UploadFiles.Response,
      AxiosResponse,
      UploadFiles.Request
    >({
      mutationFn: data => {
        return apiClient.chat.uploadChatFiles({
          chatInstanceIdentifier: data.chatInstanceIdentifier,
          files: data.files,
          context: data.context,
          identifier: data.identifier,
          brandIdentifier: data.brandIdentifier,
        });
      },
    }),
  };

  return (
    <ChatUploadApiContext.Provider value={contextValue}>
      {children}
    </ChatUploadApiContext.Provider>
  );
};